import throttle from 'lodash/throttle';

/**
 * Menu
 * sub levels will slide to view horizontally
 * */

export default class HorizontalMenu {
  /**
   * Creates Menu instance
   * @param {HTMLElement} container Menu container
   */
  constructor(container) {

    this.selectors = {
      container: '.js-horizontal-menu',
      backButton: '.js-back-btn',
      levelTrigger: '.js-open-panel',
      view: '[data-view-level]'
    };

    this.container = container;
    this.triggers = this.container.querySelectorAll(this.selectors.levelTrigger);
    this.currentLevel = 0;

    this.resizeThrottle = throttle(this._onResize.bind(this), 50);

    this.currentPanel = document.querySelector(this.selectors.view);
  }

  init() {
    this._createReturnTriggers(this.container.querySelectorAll(this.selectors.view));
    this._attachListeners();
  }

  /**
   * Attach click event listeners to buttons
   */
  _attachListeners() {

    this.triggers.forEach((trigger) => {
      //const toggleParent = toggle.parentElement;
      //trigger.setAttribute('aria-expanded', false);
      trigger.addEventListener('click', this._onTriggerClick.bind(this));


      const backButton = trigger.nextElementSibling.querySelector(this.selectors.backButton);
      if(backButton) {
        backButton.addEventListener('click', this._goBackToPrevious.bind(this));
      }
    });

    window.addEventListener('resize', this.resizeThrottle);
  }

  /**
  * WIP Removes event listeners
  */
  _removeListeners() {
    //this.triggers.removeEventListener('click', this._onTriggerClick, false);
    //this.backButtons.removeEventListener('click', this._onBackBtnClick, false);
  }

  /**
   * Make panel visible and move focus
   * @param {HTMLElement} panel Menu panel that will be opened
   * @param {HTMLElement} focusTarget Element that will receive focus (optional, defaults to first button)
   */
  _activatePanel(panel, focusTarget = null) {
    if(!panel) {
      return;
    }

    panel.classList.add('active');
    const level = panel.dataset.viewLevel;
    this._moveViewToLevel(level);
    this.currentPanel = panel;

    focusTarget = focusTarget || panel.querySelector('button');
    setTimeout(() => focusTarget.focus(), 500); //wait for the css animation to complete, before moving the focus. Otherwise browser tries to force the focus to view
  }

  _deActivatePanel(panel) {
    panel.classList.remove('active');
  }

  /**
   * Move correct level to view
   * @param {string| number} level number of the panel level
   */
  _moveViewToLevel(level = 0) {
    level = parseInt(level);
    const areaWidth = this.container.parentElement.clientWidth;
    const transformX = areaWidth * level;
    this.container.style.transform = `translateX(-${transformX}px)`;
    this.currentLevel = level;
  }

  /**
   * On clicking sub menu opener
   * @param {Event} event click event
   */
  _onTriggerClick(event) {
    const triggerButton = event.currentTarget;
    const targetPanel = triggerButton.nextElementSibling;
    this._activatePanel(targetPanel);
  }

  /**
   * Go back to previous
   */
  _goBackToPrevious() {
    const currentPanel = this.currentPanel;
    const currentPanelLevel = currentPanel.dataset.viewLevel ? parseInt(currentPanel.dataset.viewLevel): 1;
    const targetPanel = currentPanel.closest(`[data-view-level="${currentPanelLevel - 1}"]`);
    this._deActivatePanel(currentPanel);
    this._activatePanel(targetPanel);
  }

  _onResize() {
    //remove listeners on desktop screen
    this._moveViewToLevel(this.currentLevel);
  }

  /**
   * Create keyaboard focusable elements that will return view to previous panel
   * otherwise keyboard user could navigate outside the visible panel
   * @param {HTMLElement[]} panels - view panels
   */
  _createReturnTriggers(panels) {
    const trigger = document.createElement('span');
    trigger.classList.add('js-returner');
    trigger.setAttribute('tabindex', 0);
    const triggerList = [];

    //add trigger to all panels beginning from level 1
    panels.forEach((panel) => {
      if(panel.dataset.viewLevel !== '0') {
        const trigger1 = trigger.cloneNode();
        const trigger2 = trigger.cloneNode();
        panel.appendChild(trigger1);
        panel.prepend(trigger2);
        triggerList.push(trigger1, trigger2)
      }
    });

    //add focus listeners to triggers
    triggerList.forEach((trigger) => {
      trigger.addEventListener('focus', (event) => {
        this._goBackToPrevious();
      });
    });

  }

}
